import { Box, Typography, useTheme } from '@mui/material';
import quibbleaiLogo from '../../assets/images/quibbleaiLogo.svg';
import quibbleaiLogoDark from '../../assets/images/quibbleaiLogoDark.svg';

interface FooterProps {
  themeMode?: 'light' | 'dark';
}

const Footer: React.FC<FooterProps> = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const logoSrc = themeMode === 'dark' ? quibbleaiLogo : quibbleaiLogoDark;

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: { xs: '48px', sm: '56px' },
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.header,
        px: { xs: 2, sm: 3 },
        flexShrink: 0,
        position: 'sticky',
        bottom: 0,
        zIndex: 1100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: { xs: '0.813rem', sm: '0.875rem' },
            fontWeight: 400,
          }}
        >
          Powered by
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0,
          }}
        >
          <Box
            component="img"
            src={logoSrc}
            alt="Quibble AI"
            sx={{
              height: { xs: '18px', sm: '20px' },
              width: 'auto',
              display: 'block',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
